import React from "react";
import Spinner from "@/images/svg/spinner.svg";
import Image from "next/image";

export const LoadingSpinner = () => {
  return <Image width="100" height="100" src={Spinner} alt="Spinner" />;
};
